import { EventEmitter } from 'node:events';
import JsonRPC from '@exodus/json-rpc';
import assert from 'minimalistic-assert';
import ms from 'ms';
import { randomUUID } from './crypto.js';
class RPC extends JsonRPC {
    _allowedOrigins;
    _emitter = new EventEmitter();
    static parseValue(_, value) {
        if (value?.type === 'Buffer') {
            return Buffer.from(value.data);
        }
        return value;
    }
    static parse(data) {
        if (typeof data !== 'string') {
            return data;
        }
        return JSON.parse(data, RPC.parseValue);
    }
    constructor({ transport, requestTimeout = ms('5m'), allowedOrigins, }) {
        super({
            transport,
            requestTimeout,
            parse: RPC.parse,
            generateId: () => () => randomUUID(),
        });
        assert(Array.isArray(allowedOrigins), 'allowedOrigins must be provided');
        this._allowedOrigins = new Set(allowedOrigins);
    }
    // @ts-expect-error method signature does not match super's method signature, but we don't mind
    callMethod(method, params) {
        return new Promise((resolve, reject) => {
            const createResolver = (resolverFn) => (...args) => {
                window.removeEventListener('message', handleReady);
                return resolverFn(...args);
            };
            const callSuper = () => {
                super
                    .callMethod(method, params)
                    .then(createResolver(resolve), createResolver(reject));
            };
            const handleReady = async (event) => {
                if (!this._allowedOrigins.has(event.origin) ||
                    event.data !== 'rpc:ready') {
                    return;
                }
                callSuper();
            };
            window.addEventListener('message', handleReady);
            callSuper();
        });
    }
    on(eventName, listener) {
        this._emitter.on(eventName, listener);
    }
    once(eventName, listener) {
        this._emitter.once(eventName, listener);
    }
    end() {
        super.end();
        this._emitter.emit('end');
    }
}
export default RPC;
